import { Button, Input, Tooltip } from "antd";
import { DownloadIcon, SearchIcon } from "../../../../../../atoms/CustomIcons";

interface FilterProps {
  setFilters: React.Dispatch<
    React.SetStateAction<{
      type: undefined | string;
      status: undefined | string[];
      state: undefined;
      city: undefined;
      onboarding_complete_date: string[] | undefined;
      last_user_activity: string[] | undefined;
      search_text: undefined | string;
    }>
  >;
  filters: {
    type: undefined | string;
    status: undefined | string[];
    state: undefined;
    city: undefined;
    onboarding_complete_date: string[] | undefined;
    last_user_activity: string[] | undefined;
    search_text: undefined | string;
  };
  archived: boolean;
  isArchived: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function Filters(props: FilterProps) {
  const { setFilters, filters } = props;

  return (
    <div className="filtersWrapper">
      <div className="filtersTop">
        <div className="filterSearch">
          <Input
            prefix={<SearchIcon />}
            placeholder="Search measurement"
            value={filters?.search_text}
            allowClear
            onChange={(e) =>
              setFilters((prev) => ({
                ...prev,
                search_text: e.target.value,
              }))
            }
          />
        </div>

        <div className="filterDownload">
          <Tooltip title="Export the list of services">
            <Button icon={<DownloadIcon />} />
          </Tooltip>
        </div>

        <Button className="outlined-btn"> Upload CSV </Button>
      </div>
    </div>
  );
}
